module.exports = __webpack_public_path__ + "img/UK.a3f7bd79.webp";